/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageLifelineOverviewPage
 */
define(['module',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/text!./templates/SignageLifelineOverviewPage.html',
        'idis/map/IdisMap',
        'idis/service/Requester',
        '../_SignageBase',
        'dojo/dom-class',
        'dojo/dom-style',
        'app/config',
        'dojo/topic',
        'app/model/LayerStore',
        'idis/control/Locator',
        'idis/model/UserInfo',
        'app/model/DisasterInfo',
        'dojo/json',
        'dojo',
        'dojo/dom-construct',
        'idis/view/dialog/DialogChain',
        'idis/view/Loader',
        'dojo/_base/array',
        'idis/consts/QUERY',
        'app/model/Region',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, declare, lang, template, IdisMap, Requester, _SignageBase, domClass, domStyle,
    config, topic, LayerStore, Locator, UserInfo, DisasterInfo, json, dojo, domConstruct, DialogChain, Loader, array, QUERY, Region) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};
        var prevBlackoutTotalStore = {};
        var prevBlackoutItemStore = {};

        // 市町村名
        var municipalityName = null;

        // 地域コード
        var regionCd =  null;

        /**
         *
         * @class SignageLifelineOverviewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageLifelineOverviewPage~SignageLifelineOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            store: null,

            _timer: null,

            // レイヤーID
            _layerId: [],

            // 緯度経度
            _latlng: null,

            // ズーム
            _zoom: null,

            _layerControl: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 12,

            // 更新時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 市町村コード
            _municipalityCd: null,

            // 値を表示する項目のリスト
            // ライフライン情報(電話、断水・減水、ガス)値を表示する項目のリスト
            target: [
                {'item':'telCurrMunicipalityNum'},
                {'item':'telCurr', 'area':'telCurrArea'},
                {'item':'watFailRedCurrMunicipalityNum'},
                {'item':'watFailRedCurr', 'area':'watFailRedCurrArea'},
                {'item':'gusCurrMunicipalityNum'},
                {'item':'gusCurr', 'area':'gusCurrArea'}
            ],

            // ライフライン情報(停電)値を表示する項目のリスト
            blackoutTarget: [
                {'item':'powerFailureMunicNum', 'area':'powerFailureMunicNumArea'},
                {'item':'powerFailureHouseNum', 'area':'powerFailureHouseNumArea'}
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
                this.chain = DialogChain.get(this);
                this._municipalityCd = UserInfo.getSelectedMunicipalityCd();
                console.debug('ライフライン（停電）情報表示対象の市町村コード：' + this._municipalityCd);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            /**
             * テーブルを初期化します
             */
            initTable: function() {
                this.setLifelineInfo();
                this.setLifelineListInfo();
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
                this.initTable();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {

                Requester.get('/api/signage/' + this._screenId).then(lang.hitch(this,function(data) {
                    var item = data;
                    this._version = item.version;
                    // レイヤー
                    this._layerId = item.layerId;

                var self = this;

                if (item["municipalityCd"] !== null) {

                    Requester.get('/api/municipalities/' + item["municipalityCd"], {
                        headers: { 'Content-Type': 'application/json; charset=utf-8' },
                        handleAs: 'json',
                        preventCache: true
                    }).then(function (municipality) {

                        // 緯度経度
                        if (municipality.latitude && municipality['municipalityCd'] !== config.municInfo.prefMunicCd) {
                            self._latlng = [municipality.latitude, municipality.longitude];
                        } else {
                            self._latlng = [config.map.latitude, config.map.longitude];
                        }
                        // ズームサイズ指定
                        if (municipality['municipalityCd'] !== config.municInfo.prefMunicCd) {
                            self._zoom = 11;
                        } else {
                            self._zoom = 9;
                        }
        
                        // マップを初期化
                        self.initMap();
                        self.putFirstLayer();
                        // レイヤーを表示
                        self.showLayer();

                    }, function (error) {
                        console.log(error);
                    });
                } else {

                    // 振興局の緯度経度、ズームサイズを設定する
                    // 緯度経度
                    if (self._latlng === null) {
                        self._latlng = [config.map.latitude, config.map.longitude];
                    }
                    return self.setRegion(regionCd).then(lang.hitch(this, function(region){
                        self._latlng = [region.latitude, region.longitude];
                        // ズームサイズ指定
                        self._zoom = 10;

                        // マップを初期化
                        self.initMap();
                        self.putFirstLayer();
                        // レイヤーを表示
                        self.showLayer();
                    }));
                }

                }), function(error) {
                    // 処理失敗時はエラーログを出力し、エラーダイアログを表示
                    console.error(error);
                    this.chain.infoError(error);
                });
            },

            initMap: function () {

                // マップの初期化
                this.map = new IdisMap(this.id + '-map', {
                    config: config.map,
                    keyboard: false, // コメント時に+/-が使用できないため
                    touchExtend: false, // IE対応
                    minZoom: 9,
                    maxZoom: 18,
                    drawControlTooltips: false
                }).setView(this._latlng, this._zoom);

                // mapのdestroyはremoveでDojoと互換なのでownで消せる
                this.own(this.map);

                this._layerControl = this.map.layerControl;

            },

            /**
             * ライフライン（停電）情報を設定します
             */
            setLifelineListInfo: function() {
                var self = this;
                var promise = Requester.get('/data/layer/data/91/alert.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(function(item) {

                    // 表示地域に合わせてデータを絞り込む
                    var newItem = [];
                    var muniList = [];
                    if ((municipalityName === null && regionCd === '') || (municipalityName === null && regionCd === null)) {
                        newItem = item.details;
                    } else if (municipalityName !== null) {
                        newItem = item.details.filter(function(eachItem) {
                            return eachItem.name === municipalityName;
                        });
                    } else {
                        array.forEach(muniList, function(muniCd){
                            var regionData = null;
                            regionData = item.details.filter(function(eachItem) {
                                return eachItem.code === muniCd;
                            });
                            if (regionCd !== undefined) {
                                newItem.push(regionData[0]);
                            }
                        });
                    }
                    // ライフライン（停電）情報を設定
                    self.setLifelineList(self, newItem);
                    // グリッド内の前回データを更新
                    prevBlackoutItemStore = newItem;

                }, function(error) {
                    if (error.response.status === 404) {
                        console.log('ライフライン（停電）情報一覧情報が見つかりません。初期値をセットします。' + (error.message ? ('('+error.message+')') : ''));
                        var item = {'items': []};
                        self.setLifelineList(self, item);
                    } else {
                        self.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 振興局選択時の情報を取得します
             */
            setRegion: function(cd) {
                return Region.store.get(cd).then(lang.hitch(this, function(region){
                    return region ? region : null;
                }));;
            },

            /**
             * ライフライン情報(電話、断水・減水、ガス)を取得します
             */
            setLifelineInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 集計値を設定
                    var lifelineList = item.items[0];
                    municipalityName = lifelineList['municipalityName'];
                    regionCd = lifelineList['regionCd'];
                    this.setLifeline(this, lifelineList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var lifelineList = {};
                        this.setLifeline(this, lifelineList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * ライフライン情報(電話、断水・減水、ガス)を設定します
             */
            setLifeline: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[target.item].toLocaleString();
                });
                // 更新状態を設定
                this.setLifelineUpdate(self, item);
            },

            /**
             * ライフライン情報(電話、断水・減水、ガス)の更新状態を設定します
             */
            setLifelineUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem || !item) {
                    return;
                }
                var totalNum = prevItem.items[0];
                if (totalNum) {
                    if (totalNum[this.target[0].item] !== item[this.target[0].item] || totalNum[this.target[1].item] !== item[this.target[1].item]) {
                        domClass.add(self['telCurrArea'], 'update-column');
                        updateFlg = true;
                    } else {
                        domClass.remove(self['telCurrArea'], 'update-column');
                    }
                    if (totalNum[this.target[2].item] !== item[this.target[2].item] || totalNum[this.target[3].item] !== item[this.target[3].item]) {
                        domClass.add(self['watFailRedCurrArea'], 'update-column');
                        updateFlg = true;
                    } else {
                        domClass.remove(self['watFailRedCurrArea'], 'update-column');
                    }
                    if (totalNum[this.target[4].item] !== item[this.target[4].item] || totalNum[this.target[5].item] !== item[this.target[5].item]) {
                        domClass.add(self['gusCurrArea'], 'update-column');
                        updateFlg = true;
                    } else {
                        domClass.remove(self['gusCurrArea'], 'update-column');
                    }
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * ライフライン（停電）情報を設定します
             */
            setLifelineList: function(self, data) {

                var blackoutList = [];
                var powerFailureMunicNum = 0;
                var powerFailureHouseNum = 0;
                var lifelinePanelTBody = dojo.byId('lifelinePanelTBody');
                domConstruct.empty(lifelinePanelTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;

                // 画面上のページ数表示
                // 現在ページ番号
                if (data.length === undefined) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    // 全数ページ番号
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);
                }
                
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                array.forEach(data, function(item){
                    if (item.count > 0) {
                        powerFailureMunicNum += 1;
                        powerFailureHouseNum += item.count;
                    }
                });
                blackoutList.powerFailureMunicNum = powerFailureMunicNum;
                this.powerFailureMunicNum.innerHTML = powerFailureMunicNum;
                blackoutList.powerFailureHouseNum = powerFailureHouseNum;
                this.powerFailureHouseNum.innerHTML = powerFailureHouseNum.toLocaleString();
                // 更新状態を設定
                this.setBlackoutUpdate(self, blackoutList);
                prevBlackoutTotalStore[this._screenId] = blackoutList;

                var updateFlg = false;

                array.forEach(displayData, function(item){

                    // 市町村の停電情報の前回値
                    var prevBlackoutList = null;
                    if (prevBlackoutItemStore && prevBlackoutItemStore.length > 0) {
                        prevBlackoutList = prevBlackoutItemStore.filter((element) =>
                            element.code === item.code
                        )[0];
                        // 新規のデータが追加された場合は前回値を0として設定
                        if (prevBlackoutList === undefined) {
                            prevBlackoutList = {'name': '', 'count': 0};
                        }
                    }

                    // デフォルトの背景色、文字色を設定
                    var bgcolor = '#CAFFFF';
                    var fontcolor = '#000000';

                    // 停電発生中戸数に応じてセルの色を出し分け
                    // 停電発生している場合powerFailureMunicNumに+1
                    if (1 <= item.count && item.count <= 1000) {
                        bgcolor = '#F5FF00';
                    } else if (1001 <= item.count && item.count <=10000) {
                        bgcolor = '#FCC400';
                    } else if (item.count >= 10001) {
                        bgcolor = '#FF0000';
                        fontcolor = '#FFFFFF';
                    }
                    var className = '';
                    var tr = domConstruct.create('tr');
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.name, class: ' p-1 align-middle text-center fw-bold',
                         style: 'padding-left:10px; width:30%; background-color:#EEEEEE;'}), tr);

                    className = prevBlackoutList && (prevBlackoutList.count !== item.count) ? 'update-column' : '';
                    if (className) { updateFlg = true; };
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '約' + String(item.count) + '戸', style: 'padding-left:10px; width:30%; background-color: '
                         + bgcolor + '; color: ' + fontcolor + ';', class: className + ' p-1 align-middle text-center'}), tr);

                    domConstruct.place(tr, lifelinePanelTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                    // 次の画面に移動させる場合
                    // topic.publish('app/control/SignageControl::next');
                } else {
                    // 次ページ
                    this._page += 1;
                } 

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setLifelineList(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            },

            /**
             * 停電情報の更新状態を設定します
             */
            setBlackoutUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevBlackoutTotalStore[this._screenId];
                if (!prevItem || !item) {
                    return;
                }
                if (prevItem) {
                    array.forEach(this.blackoutTarget, function(blackoutTarget){
                        // 更新された項目にstyleを設定
                        if (prevItem[blackoutTarget.item] !== item[blackoutTarget.item]) {
                            domClass.add(self['powerFailureMunicNumArea'], 'update-column');
                            domClass.add(self['powerFailureHouseNumArea'], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self['powerFailureMunicNumArea'], 'update-column');
                            domClass.remove(self['powerFailureHouseNumArea'], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * レイヤー表示
             */
            showLayer: function () {
                // レイヤーIDリスト
                var layerQuery = Locator.getLayerQuery();
                
                // 停電情報(固定レイヤー)
                var layerId = 91;
                layerQuery[layerId] = layerQuery[layerId] || '0';

                // URLに反映
                Locator.replaceState(QUERY.LAYER_LIST, Locator.toLayerQuery(layerQuery));
            }
        });
    });
